/*
 * @Author: your name
 * @Date: 2020-07-11 13:43:57
 * @LastEditTime: 2020-07-17 19:34:09
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue-gaokao-ebook\src\assets\js\subject-data.js
 */ 
// const SUBJECT_COLLECTION =[
//     {1 :"初中语文" },
//     {2 :"初中数学" },
//     {3 :"初中英语" },
//     {4 :"初中物理" },
//     {5 :"初中化学" },
//     {6 :"初中生物" },
//     {7 :"初中历史" },
//     {8 :"初中地理" },
//     {9 :"高中语文" },
//     {10:"高中数学" },
//     {11:"高中英语" },
//     {12:"高中物理" },
//     {13:"高中化学" },
//     {14:"高中生物" },
//     {15:"高中历史" },
//     {16:"高中地理" },
//     {17:"高中政治" },
//     {19:"初中政治" },
//     {20:"小学奥数" },
//     {21:"小学语文" },
//     {22:"小学数学" },
//     {23:"小学英语" }
// ]

const SUBJECT_COLLECTION = {
    9 :"语文" ,
    10:"数学" ,
    11:"英语" ,
    12:"物理" ,
    13:"化学" ,
    14:"生物" ,
    15:"历史" ,
    16:"地理" ,
    17:"政治" 
}

export default SUBJECT_COLLECTION